<!-- Andres M - Actividad item 3785 -->
<template>
  <button
    class="btn btn-sm btn-link mr-2 font-weight-bold"
    @click="setTheme(!dark)"
    title="Modo oscuro / claro"
  >
    <transition name="bounce">
      <i v-if="dark" class="fas fa-sun text-warning"></i>
      <i v-else class="fas fa-moon text-dark"></i>
    </transition>
  </button>
</template>
<style>
#drawingmap-dark-mood {
  float: right;
  margin: auto;
  display: flow-root;
  padding: 8px;
  text-align: right;
  border-radius: 2px !important;
}

.main-draw-dark {
  margin-top: 5%;
  height: 1px;
  float: right;
  width: 0%;
  border-radius: 2px !important;
}
</style>
<script>
import can from "@/permission";
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      dark: "mode/getTheme",
    }),
  },
  methods: {
    ...mapActions({
      setTheme: "mode/setTheme",
    }),
    can: can,
  },
};
</script>
